export type RuTranslationsType = typeof ruTranslations;

export const ruTranslations = {
  translation: {
    actions: 'Действия',
    activate: 'Активировать',
    active: 'Активные',
    activity: 'Активность',
    allSchoolClasses: 'Классы школы',
    allSchoolGroups: 'Группы школы',
    allSchoolStudents: 'Ученики школы',
    analysisBoard: 'Анализировать партию',
    answer: 'Ответ',
    assign: 'Назначить',
    assignment: 'Контрольная работа',
    assignments: 'Контрольная работа',
    assignmentsPage: {
      addAssignment: 'Создание контрольной работы',
      assignmentConsistOf: 'Контрольная состоит из',
      callToActionCreate: 'Создайте контрольную работу',
      checkpointMessage: 'Эта контрольная работа является аттестационной. Желаем удачи!',
      chooseClass: 'Выберите класс, и мы предложим вам подходящие задания',
      chooseGroup: 'Выберите группу, и мы предложим вам подходящие задания',
      chooseTopics: 'Выберите темы',
      createAssignment: 'Создать контрольную',
      createdList: 'На этой странице появятся все контрольные, которые вы создадите',
      deadlines: 'Укажите сроки выполнения',
      editAssignment: 'Редактировать контрольную работу',
      noAssignment: 'Здесь еще нет контрольной ',
      noTopics: 'Темы для этого класса не найдены',
      noTopicsForClass: 'Темы для этого класса не найдены',
      noTopicsForGroup: 'Темы для этой группы не найдены',
      quarter: 'за четверть',
      taskHasFinished: 'Задание завершено',
      taskNotStarted: 'Задание не началось',
    },
    attempt: 'Попытка',
    attempts: 'Попытки',
    attention: 'Внимание!',
    auth: {
      auth: 'Авторизация',
      changeEmail: 'Изменить почту',
      changePassword: 'Поменять пароль',
      checkEmail: 'Проверьте свою почту!',
      confirmPassword: 'Повторите Пароль',
      email: 'Электронная почта',
      enter: 'Войти',
      enterEmail: 'Введите адрес электронной почты',
      enterNewPassword: 'Укажите новый пароль',
      errorOldPassword: 'Новый пароль должен отличаться от старого',
      finishRegister: 'Завершить регистрацию',
      forgotPassword: 'Забыли пароль?',
      incorrectLogin: 'Неверный логин или пароль',
      inviteSchoolAccepted: 'Вы приняли приглашение в новую школу!',
      inviteWrongCode: 'Приглашение или его срок действия недействительны',
      login: 'Логин',
      newPassword: 'Новый Пароль',
      password: 'Пароль',
      passwordMinLength: 'Не менее 6 символов',
      pleaseCheckEmail: 'Пожалуйста, проверьте свою почту',
      recoverPassword: 'Восстановление пароля',
      resetPassword: 'Сбросить пароль',
      resetPasswordHelpMessage: ' Или вы можете обратиться к Тренеру с просьбой сбросить пароль.',
      resetPasswordMessage: 'Введите адрес электронной почты для сброса пароля',
      schoolNotActive: 'Школа не активирована',
      schoolNotActiveCoach:
        'Ваша школа не имеет доступа в систему Chess Class, пожалуйста обратитесь координатору школы',
      schoolNotActiveStudent:
        'Ваша школа не имеет доступа в систему Chess Class, пожалуйста обратитесь к своему учителю',
      schoolNotActiveSuperCoach:
        'Ваша школа не имеет доступа в систему Chess Class, пожалуйста обратитесь к команде поддержки {{supportEmail}}',
      send: 'Отправить',
      sendConfirmation: 'Мы отправили вам сообщение с инструкциями по сбросу пароля.',
      updatePassword: 'Обновить пароль',
      userInactive: 'Пользователь с данным почтовым адресом заблокирован',
      userNotActive: 'Пользователь не активирован',
      welcome: 'Добро пожаловать',
      welcomeToChess: 'Добро пожаловать <br />в Chess <span class="text-primary">Class</span>',
    },
    author: 'Автор',
    authors: 'Авторы',
    back: 'Назад',
    birthDate: 'Дата рождения',
    boardEditorPage: {
      black: 'Черныц',
      blacksMove: 'Ход черных',
      boardEditor: 'Редактор доски',
      castling: 'Рокировка',
      clearTheBoard: 'Очистить доску',
      nextMove: 'Следующий ход',
      startingPosition: 'Начальная позиция',
      turnTheBoardOver: 'Перевернуть доску',
      white: 'Белый',
      whitesMove: 'Ход белых',
    },
    cancel: 'Отменить',
    cartoon: 'Мультфильм',
    chapter: 'Тема',
    chapter_few: 'Темы',
    chapter_many: 'Тем',
    chapter_other: 'Тем',
    chapters: 'Темы',
    chaptersPage: {
      chapterList: 'Список тем',
      recommendationForCoach: 'Рекомендация для тренера!',
    },
    choose: 'Выберите',
    chooseLanguage: 'Выберите язык',
    class: 'Класс',
    classStudio: 'Студия класса',
    classWork: 'Классная работа',
    classes: 'Классы',
    classesPage: {
      activateStudentMessage:
        'Вы уверены, что хотите дать доступ в систему для ученика {{fullName}}?',
      addClass: 'Добавить класс',
      addGroup: 'Добавить группу',
      addStudent: 'Добавить ученика',
      assignClass: 'Назначить класс',
      assignGroup: 'Назначить группу',
      backToClasses: 'Назад к классам',
      backToGroups: 'Назад к группам',
      classLetter: 'Буква класса',
      classNumber: 'Номер класса',
      createClass: 'Создать класс',
      createGroup: 'Создать группу',
      deactivateStudentMessage:
        'Вы уверены, что хотите приостановить доступ в систему для ученика {{fullName}}?',
      deleteClassMessage: 'Вы действительно хотите удалить Класс {{grade}} “{{symbol}}”?',
      deleteGroupMessage: 'Вы действительно хотите удалить группу “{{symbol}}”?',
      editClass: 'Редактировать класс',
      editCoach: 'Редактировать тренера',
      editGroup: 'Редактировать группу',
      editStudent: 'Редактировать ученика',
      editTeacher: 'Редактировать учителя',
      educationLanguage: 'Язык обучения',
      excludeFromClass: 'Удалить из класса',
      excludeFromGroup: 'Удалить из группы',
      excludeFromSchool: 'Удалить из школы',
      excludeStudentFromClass: 'Вы уверены, что хотите удалить {{fullName}} из класса?',
      excludeStudentFromGroup: 'Вы уверены, что хотите удалить {{fullName}} из группы?',
      excludeStudentFromSchool: 'Вы уверены, что хотите удалить  {{fullName}} из школы?',
      exportPdf: 'Скачать PDF',
      groupNumber: 'Номер группы',
      loginGenerate: 'Логин генерируется по полю "email"',
      myClasses: 'Мои классы',
      myGroups: 'Мои группы',
      myStudents: 'Мои ученики',
      noGrades: 'Оценки не выставлены',
      noHomework: 'Здесь еще нет домашнего задания',
      noIndependentWork: 'Здесь еще нет самостоятельных заданий',
      noStudents: 'Здесь еще нет учеников',
      resetPassword: 'Сбросить пароль',
      studentPasswordGenerate: 'Пароль ученика сгенерирован по полю “дата рождения”',
      studentsCount: 'Количество студентов',
      successActivateStudentMessage: 'Ученик успешно активирован',
      successDeactivateStudentMessage: 'Ученик успешно деактивирован',
      successExcludeStudentFromClassMessage: 'Ученик успешно удален из классса',
      successExcludeStudentFromGroupMessage: 'Ученик успешно удален из группы',
      successExcludeStudentFromSchoolMessage: 'Ученик успешно удален из школы',
      tableEmptyPlaceholder: 'Учащиеся появятся здесь после того, как поступят в вашу школу',
      unassigned: 'Неназначенные',
    },
    clear: 'Очистить',
    coach: 'Тренер',
    coaches: 'Тренеры',
    content: 'Содержание',
    copied: 'Скопировано',
    copy: 'Скопировать',
    correctLessonsCount: 'задач верно',
    create: 'Создать',
    date: 'Дата',
    delete: 'Удалить',
    edit: 'Редактировать',
    email: 'Почта',
    executionReport: 'Отчет выполнения',
    exercise: 'Упражнение',
    exerciseStatus: {
      FAILED: 'Неверно',
      HOORAYGOODANSWER: 'Ура! Это верный ответ!',
      NA: 'Не выполнено',
      SOLVED: 'Решено',
    },
    exercises: 'Упражнения',
    exit: 'Выход',
    filter: 'Фильтр',
    finish: 'Завершить',
    finishAt: 'Дата выполнения',
    finishDate: 'Срок выполнения',
    fio: 'ФИО',
    firstName: 'Имя',
    gender: {
      boy: 'Мальчик',
      female: 'Женщина',
      girl: 'Девочка',
      male: 'Мужчина',
      title: 'Пол',
    },
    givenDate: 'Выдано',
    goBack: 'Вернуться назад',
    grade: 'Оценка',
    grades: 'Оценки',
    group: 'Группа',
    groupStudio: 'Студия группы',
    groups: 'Группы',
    guideline: 'Методическое пособие',
    guidelines: 'Методические пособия',
    help: 'Помощь',
    helpModal: {
      haveQuestions: 'Возникли вопросы?',
      helpText: 'По всем вопросам Вы можете связаться с нами по почте',
    },
    hide: 'Скрыть',
    homeWorkIsDone: 'Домашнаяя работа завершена',
    homework: 'Домашнее задание',
    homeworks: 'Домашние задания',
    homeworksPage: {
      addHomework: 'Создание домашнего задания',
      attempts: 'Попыток',
      callToActionCreate: 'Создайте домашнее задание',
      chooseClass: 'Выберите класс, и мы предложим вам подходящие темы',
      chooseGroup: 'Выберите группу, и мы предложим вам подходящие темы',
      chooseTopic: 'Выберите тему',
      completed: 'Выполнено',
      correctTasksCount: '{{count}} / {{total}} задач верно',
      createHomework: 'Создать задание',
      createdList: 'На этой странице появятся все домашние задания, которые вы создадите',
      currentDeadLine: 'Крайний срок',
      deadlines: 'Укажите сроки выполнения',
      deadlinesEdit: 'Редактировать сроки выполнения',
      deleteHomeworkMessage: 'Вы действительно хотите удалить “{{name}}”',
      editDueDate: 'Редактировать срок выполнения',
      execute: 'Начать',
      homework: 'Домашние задания',
      homeworkConsistOf: 'Контрольная состоит из',
      issued: 'Выдано',
      newDeadLine: 'Новый крайний срок',
      noTopicsForClass: 'Темы для этого класса не найдены',
      noTopicsForGroup: 'Темы для этой группы не найдены',
      possible: '/ {{count}} возможных',
      startHomeworkMessage: 'Вы действительно хотите приступить к выполнению домашнего задания?',
      startIndependentMessage:
        'Вы действительно хотите приступить к выполнению самостоятельного задания?',
      successEditDueDateChange: 'Срок выполнения задания успешно изменен',
      task: 'Задача',
      tasks: 'Задачи',
      toAllStudents: 'Всем ученикам',
      usedAttemptsCount: 'Кол-во  использованных попыток',
      watchChapter: 'Посмотреть тему',
    },
    iin: 'ИИН',
    independentWork: 'Самостоятельная работа',
    independentWorks: 'Самостоятельные работы',
    invalidEmail: 'Неверный адрес электронной почты',
    language: {
      de: 'Немецкий',
      en: 'Английский',
      fr: 'Французский',
      kz: 'Казахский',
      ru: 'Русский',
    },
    lastName: 'Фамилия',
    lesson: 'Урок',
    lessons: 'Уроки',
    lessonsPage: {
      firstLevel: '1-й уровень',
      fourthLevel: '4-й уровень',
      secondLevel: '2-й уровень',
      thirdLevel: '3-й уровень',
      topicsMessage: 'Тут отображаются пройденные темы уроков',
      welcomeToChess:
        'Привет! Добро пожаловать <br />в Chess <span class="text-primary">Class</span>',
    },
    login: 'Логин',
    materials: 'Доп. материалы',
    messages: {
      birthDateShouldNotBeInTheFuture: 'Дата рождения не должна быть в будущем',
      chapterNotSelected: 'Тема не выбрана',
      dueDateCannotBeEarlierThanStartDate: 'Срок выполнения не может быть раньше даты начала',
      dueDateCannotBeEarlierThanTheCurrentDate: 'Срок выполнения не может быть раньше текущей даты',
      error: 'Произошла ошибка, попробуйте снова',
      errorEmailAlreadyUsed: 'Почтовый адрес уже используется',
      errorPostReview: 'Не удалось сохранить отзыв',
      errorProfileNotFound: 'Профиль не найден',
      errorUserNotFound: 'Пользователь не найден',
      studentNotSelected: 'Ученик не выбран',
      successAdminInvite: 'Приглашение персоналу отправлено',
      successAssignmentCreate: 'Контрольная успешно создана',
      successAssignmentDelete: 'Контрольная работа успешно удалена!',
      successAssignmentEdit: 'Контрольная работа успешно изменена',
      successAuthorDelete: 'Автор успешно удален!',
      successAuthorEdit: 'Автор успешно изменен',
      successChapterCreate: 'Тема успешно создана',
      successChapterDelete: 'Тема успешно удалена!',
      successChapterEdit: 'Тема успешно изменена',
      successChapterGive: 'Тема успешно выдана',
      successClassCreate: 'Класс успешно создан',
      successClassDelete: 'Класс успешно удален',
      successClassEdit: 'Класс успешно изменен',
      successCoachDelete: 'Тренер успешно удален!',
      successCoachEdit: 'Тренер успешно изменен',
      successExerciseDelete: 'Задача успешно удалена!',
      successExerciseGroupDelete: 'Группа упражнений удалена',
      successExerciseGroupEdit: 'Группа упражнений изменена',
      successGroupCreate: 'Группа успешно создана',
      successGroupDelete: 'Группа успешно удалена',
      successGroupEdit: 'Группа успешно изменена',
      successHomeworkCreate: 'Домашнее задание успешно создано',
      successHomeworkDelete: 'Домашнее задание успешно удалено!',
      successPasswordInvoke: 'Письмо со сбросом пароля было отправлено вам на почту',
      successPasswordUpdate: 'Пароль успешно обновлен',
      successProfileEdit: 'Профиль успешно обновлен',
      successRegister: 'Успешная регистрация',
      successReviewPost: 'Отзыв успешно сохранен',
      successSchoolDelete: 'Школа успешно удалена',
      successStaffDelete: 'Персонал успешно изменен',
      successStaffEdit: 'Персонал успешно изменен',
      successStudentAddToClass: 'Ученик успешно добавлен в класс',
      successStudentAddToGroup: 'Ученик успешно добавлен в группу',
      successStudentCreate: 'Ученик успешно создан',
      successStudentEdit: 'Ученик успешно изменен',
      successVideoDelete: 'Видео успешно удалено',
      successVideoEdit: 'Видео успешно изменено',
      successVideoFileDelete: 'Видеофайл успешно удален',
      successVideoFileEdit: 'Видеофайл успешно изменен',
      successVideoFileUpload:
        'Видеофайл успешно загружен, через некоторое время оно будет доступно для выбора',
      warningAssignmentConsistOf: 'Контрольная должна содержать минимум 1 задачу',
      warningHomeworkConsistOf: 'Домашнее задание должно содержать минимум 1 задачу/тест',
      warningSession: 'Срок действия истек или неверный формат, попробуйте снова позже',
      warningStudentEmail: 'Ученик с данной почтой уже зарегистрирован',
    },
    middleName: 'Отчество',
    modals: {
      exerciseAttemptsTooltipDescription:
        'Общее кол-во попыток можно использовать на одну задачу или распределить между несколькими задачами по вашему усмотрению. Используйте попытки разумно, чтобы максимально эффективно решить каждую задачу.',
      exerciseAttemptsTooltipTitle: 'На решение задач вам предоставлены попытки.',
      exerciseHelpText:
        'Использована большая часть попыток. Попробуй перейти к другим задачам, чтобы улучшить свой результат и увеличить шансы на успешное выполнение.',
      goodLuck: 'Удачи!',
      incorrectAnswer: 'Неверно',
      mustAnswerAllQuestions: 'Нужно ответить на все вопросы!',
      tryAgain: 'Попробуй еще',
    },
    more: 'Подробнее',
    newestFirst: 'Сначала новые',
    next: 'Далее',
    no: 'Нет',
    noResult: 'Результаты не найдены',
    notFoundResult: {
      chooseClass: 'Выберите класс"',
      chooseGroup: 'Выберите группу',
      createClass: 'Создайте класс',
      createClassHelpMessage: 'Новый класс можно создать во вкладке классы',
      createGroup: 'Создайте группу',
      createGroupHelpMessage: 'Новую группу можно создать во вкладке группы',
      goBackToAssignments: 'Вернитесь во вкладку все контрольные задания',
      goBackToHomeworks: 'Вернитесь во вкладку все домашние задания',
      noAssignment: 'Контрольная работа не найдена',
      noChapterExercises: 'Задачи не добавлены в данную тему',
      noChapters: 'Темы не найдены',
      noCoach: 'Тренер не найден',
      noHomework: 'Домашняя работа не найдена',
      noHomeworkExercises: 'Задачи в домашней работе не найдены',
      noLessons: 'Уроки не найдены',
      noMaterials: 'Дополнительные материалы не добавлены в данную тему',
      noStudent: 'Ученик не найден',
    },
    oldestFirst: 'Сначала старые',
    passed: 'Пройдено',
    pause: 'Приостановить',
    phone: 'Телефон',
    phoneNumber: 'Номер телефона',
    problem: 'Задача',
    problem_few: 'Задачи',
    problem_many: 'Задач',
    problem_other: 'Задач',
    problems: 'Задачи',
    proceed: 'Приступить',
    profile: 'Профиль',
    profilePage: {
      birthDate: 'Дата рождения',
      email: 'Email',
      emailPlaceholder: 'Введите электронную почту',
      firstName: 'Имя',
      gender: 'Пол',
      genderPlaceholder: 'Выберите пол',
      iin: 'ИИН',
      lastName: 'Фамилия',
      loginAndPassword: 'Логин и пароль',
      loginHelpText: 'Логин генерируется по полю “email”',
      middleName: 'Отчество',
      passwordRepeatError: 'Такой пароль уже был использован ранее, придумайте новый',
      personalInfo: 'Личная Информация',
      phone: 'Телефон',
      phonePlaceholder: 'Введите номер телефона',
      profileSettings: 'Настройка профиля',
      schoolAndCoach: 'Школа и тренер',
      schoolAndTeacher: 'Школа и учитель',
      withoutCoach: 'Без тренера',
      withoutCoachHelpText: 'Вы еще не подключены ни к одному тренеру',
      withoutTeacher: 'Без учителя',
      withoutTeacherHelpText: 'Вы еще не подключены ни к одному учителю',
    },
    profileSettings: 'Настройка профиля',
    report: 'Отчет',
    requiredField: 'Поле обязательно к заполнению',
    result: 'Результат',
    results: 'Результаты',
    review: {
      review: 'Оценить',
      reviewChapter: 'Пожалуйста, оцените эту тему',
      reviewExercise: 'Пожалуйста, оцените эту задачу',
      reviewLesson: 'Пожалуйста, оцените этот урок',
      reviewTest: 'Оцените вопросы самостоятельной работы, которую вы только что выполнили',
      reviewVideo: 'Пожалуйста, оцените просмотренное видео',
      tellUsMoreDetails: 'Расскажите подробнее',
      thisWillHelpUpToImprove: 'это поможет нам улучшить её',
      whatDidYouLike: 'Расскажите нам, что именно вам понравилось',
      whatYouDidntLike: 'Расскажите нам, что вам не понравилось?',
    },
    save: 'Сохранить',
    school: 'Школа',
    schools: 'Школы',
    search: 'Поиск',
    searchHelpText: 'Попробуйте изменить ваш поиск',
    seeDetails: 'Перейти',
    selfWorkIsDone: 'Самостоятельная работа завершена',
    show: 'Показать',
    solution: 'Решение',
    solvedCount: 'Выполнили',
    sortByColumnAsc: 'sortByColumnAsc',
    sortByColumnDesc: 'sortByColumnDesc',
    sortedByColumnAsc: 'sortedByColumnAsc',
    sortedByColumnDesc: 'sortedByColumnDesc',
    startAt: 'Дата выдачи',
    startDate: 'Дата начала',
    status: 'Статус',
    statuses: {
      ACTIVE: 'Активный',
      ALL: 'Все',
      AVAILABLE: 'Доступна',
      DELETED: 'Удален',
      DISABLED: 'Заблокирован',
      DRAFT: 'Черновик',
      FAILED: 'Неверно',
      FINISHED: 'Завершено',
      GIVEN: 'Выдано',
      INACTIVE: 'Приостановлен',
      INVITED: 'Приглашен',
      ISSUED: 'Выдано',
      NA: 'Не выполнено',
      NEW: 'Новый',
      NOT_AVAILABLE: 'Не доступна',
      NOT_INVITED: 'Неприглашенный',
      NOT_ISSUED: 'Не выдано',
      NOT_PASSED: 'Не пройдено',
      PASSED: 'Пройдено',
      PAUSED: 'Приостановленный',
      SOLVED: 'Решено',
    },
    student: 'Ученик',
    studentDetails: 'Детали ученика',
    studentProfile: 'Профиль ученика',
    student_few: 'Ученика',
    student_many: 'Учеников',
    student_other: 'Учеников',
    students: 'Ученики',
    studio: 'Студия',
    studiosPage: {
      alertEndLesson: 'Вы действительно хотите завершить урок?',
      attemptsLeft: 'Осталось попыток',
      available: 'Доступна',
      chooseAnswer: 'Выберите ответ',
      chooseClass: 'Выберите класс',
      chooseGroup: 'Выберите группу',
      demonstrationsStudio: 'Студия демонстраций',
      endLesson: 'Завершить урок',
      findTheBestMoveFor: 'Найди лучший ход за',
      findTheBestMoveForBlack: 'Найдите лучший ход за черных',
      findTheBestMoveForWhite: 'Найдите лучший ход за белых',
      giveHomeWork: 'Выдать домашнее задание',
      given: 'Выдана',
      hideAnswer: 'Скрыть ответ',
      hideSolution: 'Скрыть решение',
      showAnswer: 'Показать ответ',
      showSolution: 'Показать решение',
      studioView: 'Демонстрация студии класса',
      viewMoves: 'Просмотр ходов',
      weWillSuggest: 'Мы предложим вам подходящую тему и упражнения',
      yourMove: 'Ваш ход',
    },
    successPasswordResetMessage: 'Пароль успешно сброшен',
    superCoach: 'Координатор',
    superCoaches: 'Координаторы',
    teacher: 'Учитель',
    teachers: 'Учителя',
    test: 'Тест',
    tests: 'Тесты',
    time: 'Время',
    title: 'Название',
    total: 'Всего',
    tryAgainLater: 'Повторите попытку позже',
    type: 'Тип',
    understand: 'Понятно',
    videofiles: 'Видеофайлы',
    videolesson: 'Видео-урок',
    yes: 'Да',
    youHaveMoreAttempts: 'У вас остались попытки, вы можете вернуться и улучшить свой результат',
    yourResult: 'Ваш результат',
  },
};
